const Comments = {
  'id': 'Comments',
  'layout': {
    'rows': 1,
    'columns': 1
  },
  'fields': [
    {
      'id': '1',
      'type': 'PAPER_CONTAINER',
      'props': {
        'name': 'Comments',
        'label': 'Quote comment',
        'fullWidth': true
      },
      'position': {
        'row': 1,
        'col': 1,
        'colspan': 3
      },
      'children': [
        {
          'id': '0',
          'type': 'TEXT_AREA',
          'props': {
            'name': 'Comment',
            'fullWidth': true,
            'style': {
              'height': '650px'
            }
          },
        },
      ]
    },
  ]
};
export default Comments;